import {
  NETWORK_ERROR,
  SET_NETWORK_ERROR_NOTIFICATION,
  REMOVE_NETWORK_ERROR_NOTIFICATION,
} from '../constants';
import history from '../../utils/HistoryService';
import NotificationsService from '../../utils/NotificationsService';

const setNetworkError = (status) => ({
  type: NETWORK_ERROR,
  status,
});

const setNetworkErrorNotification = (origin, id) => ({
  type: SET_NETWORK_ERROR_NOTIFICATION,
  origin,
  id,
});

const removeNetworkErrorNotification = (origin) => ({
  type: REMOVE_NETWORK_ERROR_NOTIFICATION,
  origin,
});

const clearNetworkErrorNotification = (originId) => (dispatch, getState) => {
  const { errors } = getState();

  if (errors.origin[originId]) {
    NotificationsService.removeNotification(errors.origin[originId]);
    dispatch(removeNetworkErrorNotification(originId));
  }
};

// TODO: plan a better approach of handling errors and notifications
const handleNetworkError = (error, retry, originId) => (dispatch, getState) => {
  if (error && error.status) {
    const isStatusUnauthorized = error.status === 401;
    const isConflict = error.status === 409;

    dispatch(setNetworkError(error.status));

    if (isStatusUnauthorized || isConflict) {
      return history.push('/unauthorized');
    }
  }

  if (error && error.data) {
    // eslint-disable-next-line no-console
    console.error(error.data);
  } else {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  const { errors } = getState();

  // checking if an error was already thrown for this request
  // if there was already a notification, just remove it and replace it with a newer one
  if (errors.origin[originId]) {
    NotificationsService.removeNotification(errors.origin[originId]);
  }
  const notificationId = NotificationsService.triggerErrorNotification(
    error,
    retry
  );

  if (originId) {
    dispatch(setNetworkErrorNotification(originId, notificationId));
  }
};

export {
  handleNetworkError,
  setNetworkErrorNotification,
  removeNetworkErrorNotification,
  clearNetworkErrorNotification,
};
